import React from "react";

interface ArrowRightIconProps {
  size?: number;
  color?: string;
  className?: string;
}

const ArrowRightIcon: React.FC<ArrowRightIconProps> = ({
  size = 24,
  color = "#9EADB8",
  className,
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      className={className}
      viewBox="0 0 19 18"
      fill="none"
    >
      <path
        d="M7.18262 14.94L12.0726 10.05C12.6501 9.4725 12.6501 8.5275 12.0726 7.95L7.18262 3.06"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default ArrowRightIcon;
